module.exports = __webpack_public_path__ + "media/沐浴阳光.ec6c4118.mp4";